import compiler from './compiler';

export default compiler;
